import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
function VideoDuotoneGlyph(props, svgRef) {
    return (_jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 576 512", focusable: "false", "aria-hidden": true, ref: svgRef }, props, { children: [_jsx("path", { d: "M525.6 410.2L416 334.7V177.3l109.6-75.6c21.3-14.6 50.4.4 50.4 25.8v256.9c0 25.5-29.2 40.4-50.4 25.8z", opacity: 0.4 }, void 0),
            _jsx("path", { d: "M0 400.2V111.8A47.8 47.8 0 0147.8 64h288.4a47.8 47.8 0 0147.8 47.8v288.4a47.8 47.8 0 01-47.8 47.8H47.8A47.8 47.8 0 010 400.2z", className: "prefix__fa-primary" }, void 0)] }), void 0));
}
const ForwardRef = React.forwardRef(VideoDuotoneGlyph);
export default ForwardRef;
